import { Checkbox, SimpleGrid } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { Activities } from 'models/generic';
import { useTranslation } from 'react-i18next';
import { displayFormError } from 'utils/validation';
import { AccordionWithSwitch } from './AccordionWithSwitch';

export const ActivityFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, errors } = useCreateRuleFormContext();
  const dataField = 'data.heartRhythmMeasurement.activityCondition';

  return (
    <AccordionWithSwitch title={t('patients_info_activity')} dataField={dataField}>
      <Checkbox.Group
        {...getInputProps(`${dataField}.activity`)}
        error={displayFormError({ errors, dataField: `${dataField}.activity`, label: t('empty_value_select') })}
      >
        <SimpleGrid cols={3} verticalSpacing={'xs'} mb={'xs'}>
          {Object.values(Activities)
            .filter((value) => ![Activities.resting, Activities.working].includes(value))
            .map((symptom) => (
              <Checkbox key={symptom} value={symptom} label={t(`activity_${symptom}`)} disabled={values.formDisabled} />
            ))}
        </SimpleGrid>
      </Checkbox.Group>
    </AccordionWithSwitch>
  );
};
